import { PositionsTableProps } from "../../position/components/positions-table";
import { ScopeOfWork } from "../../scope-of-work/types/scope-of-work";
import {
  useOmniOfferAddScopeOfWorkPositionMutation,
  useOmniOfferPatchScopeOfWorkPositionMutation,
  useOmniOfferRemoveScopeOfWorkPositionMutation,
  useOmniOfferRemoveScopeOfWorkPositionsByGroupingMutation,
  useOmniOfferRenameScopeOfWorkGroupingMutation,
} from "../api/offer-api";
import { Offer } from "../types/offer";

/**
 * useScopeOfWorkPositionsTableProps returns the props of a
 * {@link PositionsTable} editing the positions of the scope of work of
 * the offer, all but its config.
 */
export function useScopeOfWorkPositionsTableProps(
  offer: Offer,
  scopeOfWork: ScopeOfWork,
): Omit<PositionsTableProps, "config"> {
  const ids = { id: offer.id, scopeOfWorkId: scopeOfWork.id };
  const [add] = useOmniOfferAddScopeOfWorkPositionMutation();
  const [patch] = useOmniOfferPatchScopeOfWorkPositionMutation();
  const [remove] = useOmniOfferRemoveScopeOfWorkPositionMutation();
  const [rename] = useOmniOfferRenameScopeOfWorkGroupingMutation();
  const [removeGrouping] =
    useOmniOfferRemoveScopeOfWorkPositionsByGroupingMutation();

  return {
    document: offer,
    positions: scopeOfWork.positions,
    fieldNamePrefix: `scopeOfWork.${scopeOfWork.id}.`,
    onPositionAdd: (r) => add({ ...r, ...ids }).unwrap(),
    onPositionPatch: (r) => patch({ ...r, ...ids }).unwrap(),
    onPositionRemove: (r) => remove({ ...r, ...ids }).unwrap(),
    onGroupingRename: (r) => rename({ ...r, ...ids }).unwrap(),
    onGroupingRemove: (r) => removeGrouping({ ...r, ...ids }).unwrap(),
  };
}
